<template>
  <v-card outlined class="rounded-lg">
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="heatmaps"
        hide-default-footer
        disable-pagination
        class="elevation-0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Heatmaps Events Config</v-toolbar-title>
            <v-spacer/>
            <v-dialog v-model="dialog" max-width="700px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on">New Value</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" class="d-flex">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Name"
                          filled
                          dense
                          hide-details="auto"
                          v-validate="{
                            required: true
                          }"
                          name="name"
                          :error-messages="errors.collect('name')"
                        />
                        <v-switch
                          v-model="editedItem.show"
                          label="show"
                          class="mx-2"
                          dense
                          hide-details
                        />
                      </v-col>
                      <v-col cols="12" class="d-flex">
                        <v-text-field
                          v-model="editedItem.events[0]"
                          label="Event key"
                          filled
                          dense
                          hide-details="auto"
                          v-validate="{
                            required: true
                          }"
                          name="event key"
                          :error-messages="errors.collect('event key')"
                        />
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              fab
                              x-small
                              :color="editedItem.between ? 'primary' : 'grey'"
                              class="mx-2 elevation-0"
                              outlined
                              v-bind="attrs"
                              v-on="on"
                              @click="editedItem.between = !editedItem.between"
                            >
                              <v-icon>
                                {{ mdiArrowExpandVertical }}
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Information will be received between two events</span>
                        </v-tooltip>
                        <v-text-field
                          v-if="editedItem.between"
                          v-model="editedItem.events[1]"
                          label="Second Event key"
                          filled
                          dense
                          hide-details="auto"
                          v-validate="{
                            required: true
                          }"
                          name="second event key"
                          :error-messages="errors.collect('second event key')"
                        />
                      </v-col>
                      <v-col cols="12" class="d-flex">
                        <v-switch
                          v-model="editedItem.use_custom_icon"
                          label="use custom icon for height map"
                          class="mr-1"
                          dense
                          hide-details
                        />
                        <v-text-field
                          v-model="editedItem.icon_value_path"
                          label="icon value path"
                          class="mx-1"
                          filled
                          dense
                          hide-details="auto"
                          :disabled="!editedItem.use_custom_icon"
                          :error-messages="errors.collect('icon value path')"
                          name="icon value path"
                          v-validate="{
                            required: editedItem.use_custom_icon == true
                          }"
                        />
                        <v-menu
                          open-on-hover
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              fab
                              x-small
                              outlined
                              class="mx-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon> {{ mdiInformation }} </v-icon>
                            </v-btn>
                          </template>
                          <v-card width="300">
                            <v-card-text>
                              Using the string we will indicate path to our icon value.
                              <pre><code>{{ JSON.stringify({ stats: { state: 'RUN' } }, null, 4) }}</code></pre>
                              If the key is in the depths, we must indicate the path to it through the point.
                              <pre><code>stats.state</code></pre>
                              If you don't understand what this is, contact the programmers.
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="d-flex align-top">
                        <v-textarea
                          v-model="editedItem.special_info_for_custom_icons"
                          label="Special info for custom icons"
                          filled
                          dense
                          rows="1"
                          auto-grow
                          hide-details
                          :disabled="!editedItem.use_custom_icon"
                          :error-messages="errors.collect('special info for custom icons')"
                          name="Special info for custom icons"
                          v-validate="{
                            required: editedItem.use_custom_icon == true
                          }"
                        />
                        <v-menu
                          open-on-hover
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              fab
                              x-small
                              outlined
                              class="mx-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon> {{ mdiInformation }} </v-icon>
                            </v-btn>
                          </template>
                          <v-card width="300">
                            <v-card-text>
                              Using the string we will indicate path to our icon value.
                              <pre><code>{{ JSON.stringify({ stats: { state: 'RUN' } }, null, 4) }}</code></pre>
                              If the key is in the depths, we must indicate the path to it through the point.
                              <pre><code>stats.state</code></pre>
                              If you don't understand what this is, contact the programmers.
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="d-flex">
                        <v-switch
                          v-model="editedItem.filter_by_target_value"
                          label="filter by target value"
                          class="mr-1"
                          dense
                          hide-details
                        />
                        <v-text-field
                          v-model="editedItem.target_value_for_filter"
                          label="Target value"
                          class="mx-1"
                          filled
                          dense
                          hide-details="auto"
                          :disabled="!editedItem.filter_by_target_value"
                          :error-messages="errors.collect('target value for filter')"
                          name="target value for filter"
                          v-validate="{
                            required: editedItem.filter_by_target_value == true
                          }"
                        />
                        <v-select
                          v-model="editedItem.target_value_type_for_filter"
                          :items="['string', 'integer', 'float', 'boolean']"
                          label="Target value type"
                          class="mx-1"
                          filled
                          dense
                          hide-details="auto"
                          :disabled="!editedItem.filter_by_target_value"
                          :error-messages="errors.collect('target value type for filter')"
                          name="target value type for filter"
                          v-validate="{
                            required: editedItem.filter_by_target_value == true
                          }"
                        />
                        <v-menu
                          open-on-hover
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              fab
                              x-small
                              outlined
                              class="mx-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon> {{ mdiInformation }} </v-icon>
                            </v-btn>
                          </template>
                          <v-card width="300">
                            <v-card-text>
                              These settings allow us to enable an additional filter for our heat map.
                              For example, our main character has a <b>RUN</b> state, but it is in an event <b>mc_move</b>.
                              <br>If you don't understand what this is, contact the programmers.
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="d-flex align-top">
                        <v-textarea
                          v-model="editedItem.target_value_path_for_filter"
                          label="Target value path for filter"
                          filled
                          dense
                          rows="1"
                          auto-grow
                          hide-details
                          :disabled="!editedItem.filter_by_target_value"
                          :error-messages="errors.collect('target value path for filter')"
                          name="target value path for filter"
                          v-validate="{
                            required: editedItem.filter_by_target_value == true
                          }"
                        />
                        <v-menu
                          open-on-hover
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              fab
                              x-small
                              outlined
                              class="mx-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon> {{ mdiInformation }} </v-icon>
                            </v-btn>
                          </template>
                          <v-card width="300">
                            <v-card-text>
                              Using the string we will indicate path to our target value.
                              <pre><code>{{ JSON.stringify({ stats: { state: 'RUN' } }, null, 4) }}</code></pre>
                              If the key is in the depths, we must indicate the path to it through the point.
                              <pre><code>stats.state</code></pre>
                              If you don't understand what this is, contact the programmers.
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="d-flex">
                        <v-switch
                          v-model="editedItem.use_target_value"
                          label="use target value for height map"
                          class="mr-1"
                          dense
                          hide-details
                        />
                        <v-row no-gutters>
                          <v-col cols="6">
                            <v-text-field
                              v-model="editedItem.max_value"
                              label="Max value"
                              class="mx-1 mb-2"
                              filled
                              dense
                              hide-details="auto"
                              :disabled="!editedItem.use_target_value || !['integer', 'float'].includes(editedItem.target_value_type)"
                              :error-messages="errors.collect('max value')"
                              name="max value"
                              v-validate="{
                                required: editedItem.use_target_value == true &&
                                  ['integer', 'float'].includes(editedItem.target_value_type)
                              }"
                            />
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="editedItem.min_value"
                              label="Min value"
                              class="mx-1 mb-2"
                              filled
                              dense
                              hide-details="auto"
                              :disabled="!editedItem.use_target_value || !['integer', 'float'].includes(editedItem.target_value_type)"
                              :error-messages="errors.collect('min value')"
                              name="min value"
                              v-validate="{
                                required: editedItem.use_target_value == true &&
                                  ['integer', 'float'].includes(editedItem.target_value_type)
                              }"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              v-model="editedItem.target_value_type"
                              :items="['string', 'integer', 'float', 'boolean']"
                              label="Target value type"
                              class="mx-1"
                              filled
                              dense
                              hide-details="auto"
                              :disabled="!editedItem.use_target_value"
                              :error-messages="errors.collect('target value type')"
                              name="target value type"
                              v-validate="{
                                required: editedItem.use_target_value == true
                              }"
                            />
                          </v-col>
                        </v-row>
                        <v-menu
                          open-on-hover
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              fab
                              x-small
                              outlined
                              class="mx-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon> {{ mdiInformation }} </v-icon>
                            </v-btn>
                          </template>
                          <v-card width="300">
                            <v-card-text>
                              These settings allow us to customize the height map. For example, we have <b>FPS</b> measurements and we want to build a height map that will indicate in red the <b>minimum FPS value</b>, and in green a value close to the <b>maximum</b>.
                              <br>If you don't understand what this is, contact the programmers.
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="d-flex align-top">
                        <v-textarea
                          v-model="editedItem.target_value_path_used"
                          label="Target value path for height map"
                          filled
                          dense
                          rows="1"
                          auto-grow
                          hide-details
                          :disabled="!editedItem.use_target_value"
                          :error-messages="errors.collect('target value path for height map')"
                          name="target value path for height map"
                          v-validate="{
                            required: editedItem.use_target_value == true
                          }"
                        />
                        <v-menu
                          open-on-hover
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              fab
                              x-small
                              outlined
                              class="mx-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon> {{ mdiInformation }} </v-icon>
                            </v-btn>
                          </template>
                          <v-card width="300">
                            <v-card-text>
                              Using the string we will indicate path to our target value.
                              <pre><code>{{ JSON.stringify({ current_fps: { FPS: 60 } }, null, 4) }}</code></pre>
                              If the key is in the depths, we must indicate the path to it through the point.
                              <pre><code>current_fps.FPS</code></pre>
                              If you don't understand what this is, contact the programmers.
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" class="d-flex">
                        <v-switch
                          v-model="editedItem.use_hardware_filters"
                          label="use hardware filters"
                          class="mr-1"
                          dense
                          hide-details
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" dark @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.events="{ item }">
          <div class="d-flex flex-column align-center">
            <span>{{ item.events[0] }}</span>
            <template v-if="item.between">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ mdiArrowExpandVertical }}
                  </v-icon>
                </template>
                <span>Information will be received between two events</span>
              </v-tooltip>
              <span>{{ item.events[1] }}</span>
            </template>
          </div>
        </template>
        <template v-slot:item.use_custom_icon="{ item }">
          <template v-if="item.use_custom_icon">
            Path: {{ item.icon_value_path.split(';').join(', ') }}
            <br />
            <div v-for="val in splitInfo(item.special_info_for_custom_icons)" :key="val">
              {{ val }}
            </div>
          </template>
          <template v-else>
            NO
          </template>
        </template>
        <template v-slot:item.use_hardware_filters="{ item }">
          <template v-if="item.use_hardware_filters">
            YES
          </template>
          <template v-else>
            NO
          </template>
        </template>
        <template v-slot:item.filter_by_target_value="{ item }">
          <template v-if="item.filter_by_target_value">
            Path: {{ item.target_value_path_for_filter.split(';').join(', ') }}
            <br />
            Filter by: {{ item.target_value_for_filter.split(';').join(', ') }}
          </template>
          <template v-else>
            NO
          </template>
        </template>
        <template v-slot:item.use_target_value="{ item }">
          <template v-if="item.use_target_value">
            Path: {{ item.target_value_path_used.split(';').join(', ') }}
            <br />
            Max value: {{ item.max_value }}
          </template>
          <template v-else>
            NO
          </template>
        </template>
        <template v-slot:item.show="{ item }">
          <v-tooltip v-if="item.show" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="green"
                v-bind="attrs"
                v-on="on"
                @click="updateItem({ ...item, show: false })"
              >
                <v-icon>
                  {{ mdiEye }}
                </v-icon>
              </v-btn>
            </template>
            <span>Category shown on timeline</span>
          </v-tooltip>
          <v-tooltip v-else bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="red"
                v-bind="attrs"
                v-on="on"
                @click="updateItem({ ...item, show: true })"
              >
                <v-icon>
                  {{ mdiEyeOff }}
                </v-icon>
              </v-btn>
            </template>
            <span>Category hidden on timeline</span>
          </v-tooltip>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            icon
            small
            @click="editItem(item)"
          >
            <v-icon
              small
            >
              {{ mdiPencil }}
            </v-icon>
          </v-btn>
          <v-btn
            icon
            small
            @click="deleteItem(item)"
          >
            <v-icon
              small
            >
              {{ mdiDelete }}
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiPencil, mdiDelete, mdiArrowExpandVertical, mdiEye, mdiEyeOff, mdiInformation } from '@mdi/js';
export default {
  data() {
    return {
      mdiPencil,
      mdiDelete,
      mdiEye,
      mdiEyeOff,
      mdiInformation,
      mdiArrowExpandVertical,
      dialog: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Events',
          value: 'events',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Custom icon',
          value: 'use_custom_icon',
          sortable: false
        },
        {
          text: 'Target value for filter',
          value: 'filter_by_target_value',
          sortable: false,
        },
        {
          text: 'Target value for height map',
          value: 'use_target_value',
          sortable: false,
        },
        {
          text: 'Use hardware filters',
          value: 'use_hardware_filters',
          sortable: false,
        },
        {
          text: 'Show',
          value: 'show',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          align: 'center',
          sortable: false,
        },
      ],
      heatmaps: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        show: true,
        events: ['all'],
        between: false,
        use_custom_icon: false,
        icon_value_path: null,
        special_info_for_custom_icons: null,
        filter_by_target_value: false,
        use_target_value: false,
        target_value_for_filter: null,
        target_value_type_for_filter: null,
        target_value_path_for_filter: null,
        target_value_path_used: null,
        target_value_type: null,
        use_hardware_filters: false,
        max_value: null,
        min_value: null
      },
      defaultItem: {
        name: '',
        show: true,
        events: ['all'],
        between: false,
        use_custom_icon: false,
        icon_value_path: null,
        special_info_for_custom_icons: null,
        filter_by_target_value: false,
        use_target_value: false,
        target_value_for_filter: null,
        target_value_type_for_filter: null,
        target_value_path_for_filter: null,
        target_value_path_used: null,
        use_hardware_filters: false,
        max_value: null,
        min_value: null
      },
    }
  },
  async created() {
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/telemetry/heatmap-events-config')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.heatmaps = data
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Value' : 'Edit Value';
    }
  },
  methods: {
    splitInfo(info) {
      if (!info) return []
      return info.split(';')
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    editItem (item) {
      this.editedIndex = this.heatmaps.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    async save () {
      const isValid = await this.$validator.validateAll()
      if (isValid) {
        if (this.editedIndex > -1) {
          const { data } = await this.$axios.put(
            this.$store.getters.projectPath + '/configs/telemetry/heatmap-events-config/' + this.editedItem.id,
            this.editedItem
          ).catch(error => ({ data: { err: true, message: error.response.data } }))

          if (data.err) {
            this.$toasted.error(data.message)
          } else {
            this.$set(this.heatmaps, this.editedIndex, data)
            this.close()
          }
        } else {
          const { data } = await this.$axios.post(
            this.$store.getters.projectPath + '/configs/telemetry/heatmap-events-config',
            this.editedItem
          ).catch(error => ({ data: { err: true, message: error.response.data } }))

          if (data.err) {
            this.$toasted.error(data.message)
          } else {
            this.heatmaps.push(data)
            this.close()
          }
        }
      }
    },
    async updateItem (heatmap) {
      const { data } = await this.$axios.put(
        this.$store.getters.projectPath + '/configs/telemetry/heatmap-events-config/' + heatmap.id,
        heatmap
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const index = this.heatmaps.findIndex(ev => ev.id === data.id)
        if (index !== -1) {
          this.$set(this.heatmaps, index, heatmap)
        }
        this.close()
      }
    },
    async deleteItem (heatmap) {
      const { data } = await this.$axios.delete(
        this.$store.getters.projectPath + '/configs/telemetry/heatmap-events-config/' + heatmap.id)
        .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        const index = this.heatmaps.findIndex(ev => ev.id === heatmap.id)
        if (index !== -1) {
          this.$delete(this.heatmaps, index)
        }
      }
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  }
}
</script>

<style scoped>
  .color {
    display: inline-block;
    border: 4px solid white;
    border-radius: 50% 50%;
    width: 24px;
    height: 24px;
  }

  pre {
    background-color: #f4f4f4;
    padding: 10px;
    border: 1px solid #ddd;
    overflow: auto;
  }

  code {
    font-family: monospace;
  }
</style>